<template>
  <div class="agriculture">
    <div class="content">
      <div class="row">
        <div class="col-md-6 detail-info-box">
          <h1>Agriculture Overview</h1>
          <p>
            The agriculture sector is the largest contributing sector to global
            emissions of non-CO₂ GHGs, accounting for 48% of emissions in 2015.
            Global agriculture-sector
            CH₄ and N₂O historical and projected
            emissions and the mitigation potential are estimated from the
            following source categories:
          </p>
          <ul>
            <li>Livestock (CH₄, N₂O)</li>
            <li>Croplands (CH₄, N₂O)</li>
            <li>Rice cultivation (CH₄, N₂O)</li>
          </ul>
          <p>
            Between 2015 and 2030, global agriculture-sector emissions are
            projected to increase 10%, reaching 6,339 MtCO₂e in 2030.
            Agricultural soil emissions and enteric fermentation emissions are
            projected to increase the largest amount, by 14% and 12% between
            2015 and 2030, respectively.
          </p>

          <div class="tabs">
            <b-tabs content-class="mt-2">
              <b-tab title="Emission Projections" active>
                <p>
                  Emissions in the agriculture sector are projected to increase
                  because of increased fertilizer consumption, crop production, and
                  livestock populations, which are driven by demand for animal
                  products. The growth rate in the demand for animal products is
                  expected to increase significantly in developing economies but is
                  expected to be slower or negative elsewhere.
                </p>
              </b-tab>
              <b-tab title="Mitigation Assessments">
                <p>
                  Mitigation potential from the agriculture sector is estimated to be
                  approximately 593 MtCO₂e in 2030. This mitigation potential is 9%,
                  3%, and 36% of livestock, croplands, and rice cultivation emissions,
                  respectively; 9% of overall agriculture-sector emissions; and 16% of
                  total global non-CO₂ mitigation potential in that year.
                </p>
              </b-tab>
            </b-tabs>
          </div>
        </div>
        <div class="col-md-6">
          <Chart />

          <div class="row">
            <div class="col-sm-12">
              <p>
                <strong class="space-right-25">Explore Agriculture Sectors:</strong>
              </p>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12">
              <button type="button" @click="openDialogFromPage12">Livestock</button>
              <button type="button" @click="openDialogFromPage13">Croplands</button>
              <button type="button" @click="openDialogFromPage14">Rice Cultivation</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <a11y-dialog
      id="main-dialog12"
      app-root="#app"
      dialog-root="#dialog-root"
      @dialog-ref="assignDialogReference12"
      :class-names="{}"
      :disable-native="useFallback"
    >
      <div>
        <Livestock />
      </div>
    </a11y-dialog>
    <a11y-dialog
      id="main-dialog13"
      app-root="#app"
      dialog-root="#dialog-root"
      @dialog-ref="assignDialogReference13"
      :class-names="{}"
      :disable-native="useFallback"
    >
      <div>
        <Croplands />
      </div>
    </a11y-dialog>
    <a11y-dialog
      id="main-dialog14"
      app-root="#app"
      dialog-root="#dialog-root"
      @dialog-ref="assignDialogReference14"
      :class-names="{}"
      :disable-native="useFallback"
    >
      <div>
        <RiceCultivation />
      </div>
    </a11y-dialog>
  </div>
</template>

<script>
//import $ from "jquery";
import Croplands from "@/components/agriculture/Croplands";
import Livestock from "@/components/agriculture/Livestock";
import RiceCultivation from "@/components/agriculture/RiceCultivation";
import Chart from "./ChartAgriculture";

export default {
  name: "AgricultureScreen",
  components: {
    Croplands,
    Livestock,
    RiceCultivation,
    Chart
  },
  props: {
    msg: String
  },
  data() {
    return {
      dialog12: null,
      dialog13: null,
      dialog14: null
    };
  },
  methods: {
    goToPage: function(a) {
      if (a) {
        location.href = "#/agriculture/" + a;
      }
    },
    assignDialogReference12(dialog12) {
      this.dialog12 = dialog12;
    },
    assignDialogReference13(dialog13) {
      this.dialog13 = dialog13;
    },
    assignDialogReference14(dialog14) {
      this.dialog14 = dialog14;
    },
    openDialogFromPage12() {
      if (this.dialog12) {
        this.dialog12.show();
      }
    },
    openDialogFromPage13() {
      if (this.dialog13) {
        this.dialog13.show();
      }
    },
    openDialogFromPage14() {
      if (this.dialog14) {
        this.dialog14.show();
      }
    },
    stopScrolling() {
      alert("test");
      this.$refs.fullpage.api.setAllowScrolling(false);
    }
  },
  computed: {
    useFallback() {
      return typeof window.HTMLDialogElement !== "function";
    }
  }
};
</script>
<style scoped>
h1 {
  font-weight: normal;
  font-size: 2rem;
  margin-bottom: 1rem;
}
.agriculture {
  z-index: 0;
}
.content {
  padding-left: 150px;
  padding-right: 150px;
}
.placeholder {
  width: 80%;
  height: 80%;
  background-color: #ececec;
  margin: 10%;
}
img {
  margin-left: 3rem;
}

@media all and (max-width: 1280px) {
  .content {
    padding-left: 80px;
    padding-right: 80px;
  }
}

@media all and (max-width: 980px) {
  .agriculture {
    background-position: 0 -40px;
  }
  .content {
    margin-top: 70px;
    padding-left: 50px;
    padding-right: 50px;
  }
}

@media all and (max-width: 736px) {
  h1 {
    font-size: 1.5rem;
  }
  .agriculture {
    position: static;
  }
}
</style>
